import {nil} from "../typer/nullish";
import {erNil} from "./nilsjekk";

/** Returnerer sann dersom settene er like. */
export function erLikeSet<T>(a:Set<T>|nil, b:Set<T>|nil):boolean{
    if (erNil(a) && erNil(b)) return true;
    if (erNil(a) || erNil(b)) return false;

    if (a.size != b.size) return false;
    for (const a_innslag of a.keys())
        if (!b.has(a_innslag)) return false;

    return true;
}
